import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { HelpService } from "../../../shared/services/help.service";
import { CustomerAdminService } from "../../../shared/services/customer-maintenance/customer-admin.service";
import { Subscription } from "rxjs";
import {
  CustomerAccountTrailModel
} from "../../../shared/models/customer-maintenance/audit-trail/customer-account-trail.model";
import {
  CustomerAddressTrailModel
} from "../../../shared/models/customer-maintenance/audit-trail/customer-address-trail.model";
import {
  CustomerContactTrailModel
} from "../../../shared/models/customer-maintenance/audit-trail/customer-contact-trail.model";
import {
  CustomerCreditManagementTrailModel
} from "../../../shared/models/customer-maintenance/audit-trail/customer-credit-management.model";
import {
  CustomerInvoiceTrailModel
} from "../../../shared/models/customer-maintenance/audit-trail/customer-invoice.model";
import {
  CustomerPaymentTermsTrailModel
} from "../../../shared/models/customer-maintenance/audit-trail/customer-paymentterms.model";

@Component({
    selector: 'app-cust-audit-trail-dialog',
    templateUrl: './cust-audit-trail-dialog.component.html',
    styleUrls: ['./cust-audit-trail-dialog.component.scss'],
    standalone: false
})
export class CustAuditTrailDialogComponent implements OnInit, OnDestroy {

  auditResponse: any[];
  auditResponseAccount: CustomerAccountTrailModel[];
  auditResponseAddress: CustomerAddressTrailModel[];
  auditResponseContact: CustomerContactTrailModel[];
  auditResponseCreditManagement: CustomerCreditManagementTrailModel[];
  auditResponseInvoice: CustomerInvoiceTrailModel[];
  auditResponsePaymentTerms: CustomerPaymentTermsTrailModel[];
  isLoading = false;
  numberRecords = 5;

  private customerAuditTrailSubs: Subscription;

  constructor(
    private readonly helpService: HelpService,
    private readonly customerAdminService: CustomerAdminService,
    @Inject(MAT_DIALOG_DATA) public data:
      {
        auditPath: string,
        auditTitle: string,
        customerID: number
      }
  ) { }

  ngOnInit(): void {
    this.getCustomerAuditTrail();
  }

  ngOnDestroy(): void {
    if (this.customerAuditTrailSubs) { this.customerAuditTrailSubs.unsubscribe(); }
  }

  auditListSlice(size: number): void {
    this.numberRecords = size;
    const auditResponseSlice = this.auditResponse.slice(0, size);
    switch ( this.data.auditPath ) {
      case 'CustomerAccount':
        this.auditResponseAccount = auditResponseSlice as CustomerAccountTrailModel[];
        break;
      case 'CustomerAddress':
        this.auditResponseAddress = auditResponseSlice as CustomerAddressTrailModel[];
        break;
      case 'CustomerContact':
        this.auditResponseContact = auditResponseSlice as CustomerContactTrailModel[];
        break;
      case 'CustomerCreditManagement':
        this.auditResponseCreditManagement = auditResponseSlice as CustomerCreditManagementTrailModel[];
        break;
      case 'CustomerInvoice':
        this.auditResponseInvoice = auditResponseSlice as CustomerInvoiceTrailModel[];
        break;
      case 'CustomerPaymentTerm':
        this.auditResponsePaymentTerms = auditResponseSlice as CustomerPaymentTermsTrailModel[];
        break;
    }
  }

  private getCustomerAuditTrail(): void {
    this.isLoading = true;
    this.customerAuditTrailSubs = this.customerAdminService.getCustomerAuditTrail(this.data.auditPath, this.data.customerID)
      .subscribe({
      next: (response) => {
        this.auditResponse = response || [];
        this.auditResponse = [...this.auditResponse].reverse();
        this.auditListSlice(5);
        this.isLoading = false;
      },
      error: () => {
        this.helpService.showMessageNotification('Error! Please try again.', 'danger');
        this.isLoading = false;
      }
    });
  }

}
